import { makeVar } from '@apollo/client'

export const page = makeVar('classic')